import { useCallback, useEffect } from 'react';

import { useApiDelete } from '../../api/Api.hooks';
import { useAppContext } from '../../AppContext';

export default function useDeleteStudyToFavorite(
  userId: number | undefined,
  studyId: number
) {
  const path =
    userId != null
      ? `users/${userId}/favorite/study/${studyId}`
      : `users/0/favorite/study/${studyId}`;

  const { data, isLoading, error, del, clearData } = useApiDelete(path);

  const { logError } = useAppContext();
  useEffect(
    () => void (error && logError('Delete to favorite error', error)),
    [error, logError]
  );

  const deleteStudyToFavorite = useCallback(() => {
    if (userId == null) {
      return;
    }
    del();
  }, [del, userId]);
  return {
    deleteStudyToFavoriteData: data,
    deleteStudyToFavoriteIsLoading: isLoading,
    deleteStudyToFavoriteError: error,
    clearDeleteStudyToFavoriteData: clearData,
    deleteStudyToFavorite
  };
}
